import { render } from "./detallePolizaExistente.vue?vue&type=template&id=2ba3ae5c"
import script from "./detallePolizaExistente.vue?vue&type=script&lang=js"
export * from "./detallePolizaExistente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__